"use client";

import { useTranslations } from "next-intl";

/**
 * Drawer success state — Figma 5462:52328 (Phase 2).
 *
 * Two-line message, newline preserved via whitespace-pre-line. AC-15 (wallet
 * path success), AC-18 (staked path success).
 */

export const VoteDrawerSuccess: React.FC = () => {
  const t = useTranslations("dao");
  return (
    <p className="whitespace-pre-line text-center text-base font-semibold text-text-primary leading-[1.4]">
      {t("voting.success.message")}
    </p>
  );
};
